var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4956_652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.898438,
    y: 0.794922,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4956_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2638 20.1618L21.4888 11.9368L19.8555 10.3034L13.2638 16.8951L9.9388 13.5701L8.30547 15.2034L13.2638 20.1618ZM14.8971 26.4618C13.2832 26.4618 11.7666 26.1555 10.3471 25.543C8.92769 24.9305 7.69297 24.0993 6.64297 23.0493C5.59297 21.9993 4.76172 20.7645 4.14922 19.3451C3.53672 17.9256 3.23047 16.409 3.23047 14.7951C3.23047 13.1812 3.53672 11.6645 4.14922 10.2451C4.76172 8.82564 5.59297 7.59092 6.64297 6.54092C7.69297 5.49092 8.92769 4.65967 10.3471 4.04717C11.7666 3.43467 13.2832 3.12842 14.8971 3.12842C16.511 3.12842 18.0277 3.43467 19.4471 4.04717C20.8666 4.65967 22.1013 5.49092 23.1513 6.54092C24.2013 7.59092 25.0326 8.82564 25.6451 10.2451C26.2576 11.6645 26.5638 13.1812 26.5638 14.7951C26.5638 16.409 26.2576 17.9256 25.6451 19.3451C25.0326 20.7645 24.2013 21.9993 23.1513 23.0493C22.1013 24.0993 20.8666 24.9305 19.4471 25.543C18.0277 26.1555 16.511 26.4618 14.8971 26.4618Z",
    fill: "#EA7F4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.fc52212c25f3d5bc6e10336f6ed8ad56.svg";
export { ForwardRef as ReactComponent };